import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Link } from 'react-router';
import { useState } from 'react';

const popupImages = {
	banner1: require('@/assets/images/img_popup1.jpg')
};
const popupBanner = [{ src: popupImages.banner1, link: 'https://www.stella-erp.com' }];

const PopupBanner = () => {
	const [bannerClosed, setBannerClosed] = useState(false); // 닫기 여부

	return (
		<div className={`popup-banner ${!bannerClosed ? 'active' : ''}`}>
			<Swiper
				modules={[Pagination, Autoplay]}
				spaceBetween={0}
				slidesPerView={1}
				loop
				autoplay={{
					delay: 5000,
					speed: 5000
				}}
				observer={true}
				observeParents={true}>
				{popupBanner.map((slide, index) => (
					<SwiperSlide key={index}>
						<Link to={slide.link} target="_blank">
							<img src={slide.src} />
						</Link>
					</SwiperSlide>
				))}
				<div className="swiper-pagination"></div>
			</Swiper>

			<div className="popup-banner-btns">
				<button type="button" className="popup-banner-btn btn1 hidden">
					일주일간 보지 않기
				</button>
				<button type="button" className="popup-banner-btn btn2" onClick={() => setBannerClosed(true)}>
					닫기
				</button>
			</div>
		</div>
	);
};

export default PopupBanner;
